module.exports = __webpack_public_path__ + "static/img/banner_3_no_red.59670f84.jpg";